// API base URL
// export const BASEURL = 'http://172.16.1.157:3000/api/'; // kashif
export const BASEURL = 'https://backend.ormeagent.com/api/'; // production
// export const BASEURL = 'https://devbackend.agentzena.com/api/'; // development

// Widget script base URL
export const WIDGET_URL = 'https://widget.agentzena.ai'; // production
// export const WIDGET_URL = 'https://widgetdev.agentzena.ai'; // development

// Manage Url
export const MANAGE_URL = 'https://manage.agentzena.ai'; // production
// export const MANAGE_URL = 'https://managedev.agentzena.ai'; // development